/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type ScheduleEventFragment = {
  userId: number | null;
  type: Types.ScheduleEventType | null;
  scheduleEventId: string | null;
  status: number | null;
  created: number | null;
  afterBuffer: number | null;
  beforeBuffer: number | null;
  comment: string | null;
  endsAt: number | null;
  gdprSeen: boolean | null;
  isRecur: boolean | null;
  locksDayAfter: boolean | null;
  prepaidAmount: number | null;
  prepaidDeadline: number | null;
  startsAt: number | null;
  prepaidPaid: boolean | null;
  title: string | null;
  packages: Array<string | null> | null;
  oldClientId: string | null;
  organizationClientId: string | null;
  questionnaireAnswers: string | null;
  questionnaireSent: boolean | null;
  newSessionId: string | null;
  hasNewPricing: boolean | null;
  recurConfig: {
    value: number | null;
    dayOfAWeekRepeat: Array<number | null> | null;
    endsAtDate: string | null;
    excluded: Array<string | null> | null;
    monthRecur: Types.MonthRecurConfig | null;
    endsAtType: Types.RecurEndType | null;
    unit: Types.RecurUnitTypes | null;
  } | null;
};

export type GetMineScheduleEventsQueryVariables = Exact<{
  userId?: number | null | undefined;
}>;

export type GetMineScheduleEventsQuery = {
  getAllScheduleEventsForUser: Array<{
    userId: number | null;
    type: Types.ScheduleEventType | null;
    scheduleEventId: string | null;
    status: number | null;
    created: number | null;
    afterBuffer: number | null;
    beforeBuffer: number | null;
    comment: string | null;
    endsAt: number | null;
    gdprSeen: boolean | null;
    isRecur: boolean | null;
    locksDayAfter: boolean | null;
    prepaidAmount: number | null;
    prepaidDeadline: number | null;
    startsAt: number | null;
    prepaidPaid: boolean | null;
    title: string | null;
    packages: Array<string | null> | null;
    oldClientId: string | null;
    organizationClientId: string | null;
    questionnaireAnswers: string | null;
    questionnaireSent: boolean | null;
    newSessionId: string | null;
    hasNewPricing: boolean | null;
    recurConfig: {
      value: number | null;
      dayOfAWeekRepeat: Array<number | null> | null;
      endsAtDate: string | null;
      excluded: Array<string | null> | null;
      monthRecur: Types.MonthRecurConfig | null;
      endsAtType: Types.RecurEndType | null;
      unit: Types.RecurUnitTypes | null;
    } | null;
  } | null> | null;
};

export type GetAllMinePackagesQueryVariables = Exact<{
  organizationId: string;
}>;

export type GetAllMinePackagesQuery = {
  getAllMinePackages: Array<{
    level: number | null;
    color: string | null;
    price: number | null;
    status: number | null;
    title: string | null;
    photoPackageId: string | null;
    duration: number | null;
    beforeTime: number | null;
    afterTime: number | null;
    marketingDescription: string | null;
    messageToClient: string | null;
    sessionCategoryId: string | null;
    slotOnly: boolean | null;
    refundablePrepaid: number | null;
    unrefundablePrepaid: number | null;
    timeToConfirm: number | null;
    currencyId: string | null;
  } | null> | null;
};

export type GetAllMineSessionCategoriesQueryVariables = Exact<{
  organizationId: string;
}>;

export type GetAllMineSessionCategoriesQuery = {
  getAllMineSessionCategories: Array<{
    title: string | null;
    parentId: string | null;
    sessionCategoryId: string | null;
    status: number | null;
    fileName: string | null;
  } | null> | null;
};

export type GetAllMineBookingSessionCategoriesQueryVariables = Exact<{
  organizationId: string;
}>;

export type GetAllMineBookingSessionCategoriesQuery = {
  getAllMineBookingSessionCategories: Array<{
    parentId: string | null;
    bookingSessionCategoryId: string | null;
    deleted: boolean | null;
    visualPersonalization: string | null;
    order: number | null;
    imagesCount: {
      all: number | null;
      hasPeople: boolean | null;
      imagesCountId: string | null;
      uploadInProgress: number | null;
    } | null;
    title: Array<{
      text: string | null;
      language: string | null;
    } | null> | null;
    description: Array<{
      text: string | null;
      language: string | null;
    } | null> | null;
    cover: {
      coverSetupId: string | null;
      file: string | null;
      x: number | null;
      y: number | null;
      size: { w: number | null; h: number | null } | null;
    } | null;
    bookingPackageComponents: Array<{
      addToAll: boolean | null;
      bookingPackageComponentId: string | null;
      name: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      value: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
    } | null> | null;
    photoPackages: Array<{
      locksDayAfter: boolean | null;
      recommended: boolean | null;
      level: number | null;
      color: string | null;
      deleted: boolean | null;
      bookingPhotoPackageId: string | null;
      preReservationBuffer: number | null;
      duration: number | null;
      beforeTime: number | null;
      beforeTimeActive: boolean | null;
      afterTime: number | null;
      afterTimeActive: boolean | null;
      marketingDescription: string | null;
      slotOnly: boolean | null;
      timeToConfirm: number | null;
      currencyId: string | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      title: Array<{
        text: string | null;
        language: string | null;
      } | null> | null;
      messageToClient: Array<{
        text: string | null;
        language: string | null;
      } | null> | null;
      availableBookingPackageAdditions: Array<{
        usedBookingPackageAdditionId: string | null;
        affectPrice: boolean | null;
        affectDuration: boolean | null;
        duration: number | null;
        limit: number | null;
        price: Array<{
          code: string | null;
          price: number | null;
        } | null> | null;
        title: Array<{
          language: string | null;
          text: string | null;
        } | null> | null;
      } | null> | null;
      settlements: {
        basicSessionPrice: {
          isSet: boolean | null;
          alreadyPaid: boolean | null;
          paidOnline: boolean | null;
          price: Array<{
            price: number | null;
            code: string | null;
          } | null> | null;
        } | null;
        onlinePayments: {
          isSet: boolean | null;
          dotPay: boolean | null;
          payPal: boolean | null;
          przelewy24: boolean | null;
        } | null;
        requiredPrePayment: {
          alreadyPaid: boolean | null;
          isSet: boolean | null;
          prePaidOption: Types.PrepaidOptions | null;
          price: Array<{
            code: string | null;
            price: number | null;
          } | null> | null;
        } | null;
      } | null;
      packageTraits: Array<{
        active: boolean | null;
        show: boolean | null;
        bookingPackageComponentId: string | null;
        value: Array<{
          language: string | null;
          text: string | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

export type GetScheduleEventOldTemplateIdQueryVariables = Exact<{
  scheduleEventId: string;
}>;

export type GetScheduleEventOldTemplateIdQuery = {
  getScheduleEventOldTemplateId: string | null;
};

export type GetOrganizationClientIdForScheduleEventQueryVariables = Exact<{
  scheduleEventId: string;
  organizationId: string;
}>;

export type GetOrganizationClientIdForScheduleEventQuery = {
  getOrganizationClientIdForScheduleEvent: string | null;
};

export type GetListOfOldPrivateSessionTemplatesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetListOfOldPrivateSessionTemplatesQuery = {
  getMineOldPrivateSessionConfigTemplates: Array<{
    configId: string | null;
    name: string | null;
  } | null> | null;
};

export type AddScheduleEventToPrivateSessionMutationVariables = Exact<{
  scheduleEventId: string;
  privateSessionId: string;
}>;

export type AddScheduleEventToPrivateSessionMutation = {
  addScheduleEventToPrivateSession: {
    scheduleEventId: string | null;
    newSessionId: string | null;
  } | null;
};

export type UpdateScheduleEventMutationVariables = Exact<{
  scheduleEventId: string;
  scheduleEvent: Types.ScheduleEventInput;
}>;

export type UpdateScheduleEventMutation = {
  updateScheduleEvent: {
    scheduleEventId: string | null;
    userId: number | null;
    type: Types.ScheduleEventType | null;
    status: number | null;
    created: number | null;
    afterBuffer: number | null;
    beforeBuffer: number | null;
    comment: string | null;
    endsAt: number | null;
    gdprSeen: boolean | null;
    isRecur: boolean | null;
    locksDayAfter: boolean | null;
    prepaidAmount: number | null;
    prepaidDeadline: number | null;
    startsAt: number | null;
    prepaidPaid: boolean | null;
    title: string | null;
    packages: Array<string | null> | null;
    oldClientId: string | null;
    organizationClientId: string | null;
    questionnaireAnswers: string | null;
    questionnaireSent: boolean | null;
    newSessionId: string | null;
    hasNewPricing: boolean | null;
    recurConfig: {
      value: number | null;
      dayOfAWeekRepeat: Array<number | null> | null;
      endsAtDate: string | null;
      excluded: Array<string | null> | null;
      monthRecur: Types.MonthRecurConfig | null;
      endsAtType: Types.RecurEndType | null;
      unit: Types.RecurUnitTypes | null;
    } | null;
  } | null;
};

export type InsertScheduleEventMutationVariables = Exact<{
  scheduleEventId: string;
  scheduleEvent: Types.ScheduleEventInput;
}>;

export type InsertScheduleEventMutation = {
  insertScheduleEvent: {
    scheduleEventId: string | null;
    userId: number | null;
    type: Types.ScheduleEventType | null;
    status: number | null;
    created: number | null;
    afterBuffer: number | null;
    beforeBuffer: number | null;
    comment: string | null;
    endsAt: number | null;
    gdprSeen: boolean | null;
    isRecur: boolean | null;
    locksDayAfter: boolean | null;
    prepaidAmount: number | null;
    prepaidDeadline: number | null;
    startsAt: number | null;
    prepaidPaid: boolean | null;
    title: string | null;
    packages: Array<string | null> | null;
    oldClientId: string | null;
    organizationClientId: string | null;
    questionnaireAnswers: string | null;
    questionnaireSent: boolean | null;
    newSessionId: string | null;
    hasNewPricing: boolean | null;
    recurConfig: {
      value: number | null;
      dayOfAWeekRepeat: Array<number | null> | null;
      endsAtDate: string | null;
      excluded: Array<string | null> | null;
      monthRecur: Types.MonthRecurConfig | null;
      endsAtType: Types.RecurEndType | null;
      unit: Types.RecurUnitTypes | null;
    } | null;
  } | null;
};

export type ScheduleEventUpdatedSubscriptionVariables = Exact<{
  organizationId: string;
}>;

export type ScheduleEventUpdatedSubscription = {
  scheduleEventUpdated: {
    userId: number | null;
    type: Types.ScheduleEventType | null;
    scheduleEventId: string | null;
    status: number | null;
    created: number | null;
    afterBuffer: number | null;
    beforeBuffer: number | null;
    comment: string | null;
    endsAt: number | null;
    gdprSeen: boolean | null;
    isRecur: boolean | null;
    locksDayAfter: boolean | null;
    prepaidAmount: number | null;
    prepaidDeadline: number | null;
    startsAt: number | null;
    prepaidPaid: boolean | null;
    title: string | null;
    packages: Array<string | null> | null;
    oldClientId: string | null;
    organizationClientId: string | null;
    questionnaireAnswers: string | null;
    questionnaireSent: boolean | null;
    newSessionId: string | null;
    hasNewPricing: boolean | null;
    recurConfig: {
      value: number | null;
      dayOfAWeekRepeat: Array<number | null> | null;
      endsAtDate: string | null;
      excluded: Array<string | null> | null;
      monthRecur: Types.MonthRecurConfig | null;
      endsAtType: Types.RecurEndType | null;
      unit: Types.RecurUnitTypes | null;
    } | null;
  } | null;
};

export type ScheduleEventAddedSubscriptionVariables = Exact<{
  organizationId: string;
}>;

export type ScheduleEventAddedSubscription = {
  scheduleEventAdded: {
    userId: number | null;
    type: Types.ScheduleEventType | null;
    scheduleEventId: string | null;
    status: number | null;
    created: number | null;
    afterBuffer: number | null;
    beforeBuffer: number | null;
    comment: string | null;
    endsAt: number | null;
    gdprSeen: boolean | null;
    isRecur: boolean | null;
    locksDayAfter: boolean | null;
    prepaidAmount: number | null;
    prepaidDeadline: number | null;
    startsAt: number | null;
    prepaidPaid: boolean | null;
    title: string | null;
    packages: Array<string | null> | null;
    oldClientId: string | null;
    organizationClientId: string | null;
    questionnaireAnswers: string | null;
    questionnaireSent: boolean | null;
    newSessionId: string | null;
    hasNewPricing: boolean | null;
    recurConfig: {
      value: number | null;
      dayOfAWeekRepeat: Array<number | null> | null;
      endsAtDate: string | null;
      excluded: Array<string | null> | null;
      monthRecur: Types.MonthRecurConfig | null;
      endsAtType: Types.RecurEndType | null;
      unit: Types.RecurUnitTypes | null;
    } | null;
  } | null;
};

export type GenerateGoogleCalendarAuthLinkQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GenerateGoogleCalendarAuthLinkQuery = {
  generateGoogleCalendarAuthLink: string | null;
};

export type GetMineWorkingHoursQueryVariables = Exact<{ [key: string]: never }>;

export type GetMineWorkingHoursQuery = {
  getMineWorkingHours: Array<{
    day: number | null;
    endsAt: number | null;
    startsAt: number | null;
    isWorking: boolean | null;
    workingHourId: number | null;
  } | null> | null;
};

export type BookingSessionCategoryFragment = {
  parentId: string | null;
  bookingSessionCategoryId: string | null;
  deleted: boolean | null;
  visualPersonalization: string | null;
  order: number | null;
  imagesCount: {
    all: number | null;
    hasPeople: boolean | null;
    imagesCountId: string | null;
    uploadInProgress: number | null;
  } | null;
  title: Array<{ text: string | null; language: string | null } | null> | null;
  description: Array<{
    text: string | null;
    language: string | null;
  } | null> | null;
  cover: {
    coverSetupId: string | null;
    file: string | null;
    x: number | null;
    y: number | null;
    size: { w: number | null; h: number | null } | null;
  } | null;
  bookingPackageComponents: Array<{
    addToAll: boolean | null;
    bookingPackageComponentId: string | null;
    name: Array<{ language: string | null; text: string | null } | null> | null;
    value: Array<{
      language: string | null;
      text: string | null;
    } | null> | null;
  } | null> | null;
  photoPackages: Array<{
    locksDayAfter: boolean | null;
    recommended: boolean | null;
    level: number | null;
    color: string | null;
    deleted: boolean | null;
    bookingPhotoPackageId: string | null;
    preReservationBuffer: number | null;
    duration: number | null;
    beforeTime: number | null;
    beforeTimeActive: boolean | null;
    afterTime: number | null;
    afterTimeActive: boolean | null;
    marketingDescription: string | null;
    slotOnly: boolean | null;
    timeToConfirm: number | null;
    currencyId: string | null;
    price: Array<{ code: string | null; price: number | null } | null> | null;
    title: Array<{
      text: string | null;
      language: string | null;
    } | null> | null;
    messageToClient: Array<{
      text: string | null;
      language: string | null;
    } | null> | null;
    availableBookingPackageAdditions: Array<{
      usedBookingPackageAdditionId: string | null;
      affectPrice: boolean | null;
      affectDuration: boolean | null;
      duration: number | null;
      limit: number | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      title: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
    } | null> | null;
    settlements: {
      basicSessionPrice: {
        isSet: boolean | null;
        alreadyPaid: boolean | null;
        paidOnline: boolean | null;
        price: Array<{
          price: number | null;
          code: string | null;
        } | null> | null;
      } | null;
      onlinePayments: {
        isSet: boolean | null;
        dotPay: boolean | null;
        payPal: boolean | null;
        przelewy24: boolean | null;
      } | null;
      requiredPrePayment: {
        alreadyPaid: boolean | null;
        isSet: boolean | null;
        prePaidOption: Types.PrepaidOptions | null;
        price: Array<{
          code: string | null;
          price: number | null;
        } | null> | null;
      } | null;
    } | null;
    packageTraits: Array<{
      active: boolean | null;
      show: boolean | null;
      bookingPackageComponentId: string | null;
      value: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

export type GetBookingPhotoAdditionsQueryVariables = Exact<{
  organizationId: string;
}>;

export type GetBookingPhotoAdditionsQuery = {
  getBookingPhotoAdditions: Array<{
    duration: number | null;
    deleted: boolean | null;
    affectDuration: boolean | null;
    affectPrice: boolean | null;
    bookingPackageAdditionId: string | null;
    description: Array<{
      text: string | null;
      language: string | null;
    } | null> | null;
    price: Array<{ code: string | null; price: number | null } | null> | null;
    name: Array<{ text: string | null; language: string | null } | null> | null;
  } | null> | null;
};

export type UpdateBookingPhotographersSortOrderMutationVariables = Exact<{
  bookingSort?:
    | Array<Types.BookingPhotographerSortInput | null | undefined>
    | Types.BookingPhotographerSortInput
    | null
    | undefined;
}>;

export type UpdateBookingPhotographersSortOrderMutation = {
  updateBookingPhotographersSortOrder: { status: boolean | null } | null;
};

export type UpdateBookingCategoriesSortOrderMutationVariables = Exact<{
  bookingSort?:
    | Array<Types.BookingCategorySortInput | null | undefined>
    | Types.BookingCategorySortInput
    | null
    | undefined;
}>;

export type UpdateBookingCategoriesSortOrderMutation = {
  updateBookingCategoriesSortOrder: { status: boolean | null } | null;
};

export type UpdateBookingPackagesSortOrderMutationVariables = Exact<{
  bookingSort?:
    | Array<Types.BookingPackageSortInput | null | undefined>
    | Types.BookingPackageSortInput
    | null
    | undefined;
}>;

export type UpdateBookingPackagesSortOrderMutation = {
  updateBookingPackagesSortOrder: { status: boolean | null } | null;
};

export type InsertBookingCategoryMutationVariables = Exact<{
  organizationId: string;
  bookingSessionCategory: Types.BookingSessionCategoryInsert;
}>;

export type InsertBookingCategoryMutation = {
  insertBookingCategory: {
    parentId: string | null;
    bookingSessionCategoryId: string | null;
    deleted: boolean | null;
    visualPersonalization: string | null;
    order: number | null;
    imagesCount: {
      all: number | null;
      hasPeople: boolean | null;
      imagesCountId: string | null;
      uploadInProgress: number | null;
    } | null;
    title: Array<{
      text: string | null;
      language: string | null;
    } | null> | null;
    description: Array<{
      text: string | null;
      language: string | null;
    } | null> | null;
    cover: {
      coverSetupId: string | null;
      file: string | null;
      x: number | null;
      y: number | null;
      size: { w: number | null; h: number | null } | null;
    } | null;
    bookingPackageComponents: Array<{
      addToAll: boolean | null;
      bookingPackageComponentId: string | null;
      name: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      value: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
    } | null> | null;
    photoPackages: Array<{
      locksDayAfter: boolean | null;
      recommended: boolean | null;
      level: number | null;
      color: string | null;
      deleted: boolean | null;
      bookingPhotoPackageId: string | null;
      preReservationBuffer: number | null;
      duration: number | null;
      beforeTime: number | null;
      beforeTimeActive: boolean | null;
      afterTime: number | null;
      afterTimeActive: boolean | null;
      marketingDescription: string | null;
      slotOnly: boolean | null;
      timeToConfirm: number | null;
      currencyId: string | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      title: Array<{
        text: string | null;
        language: string | null;
      } | null> | null;
      messageToClient: Array<{
        text: string | null;
        language: string | null;
      } | null> | null;
      availableBookingPackageAdditions: Array<{
        usedBookingPackageAdditionId: string | null;
        affectPrice: boolean | null;
        affectDuration: boolean | null;
        duration: number | null;
        limit: number | null;
        price: Array<{
          code: string | null;
          price: number | null;
        } | null> | null;
        title: Array<{
          language: string | null;
          text: string | null;
        } | null> | null;
      } | null> | null;
      settlements: {
        basicSessionPrice: {
          isSet: boolean | null;
          alreadyPaid: boolean | null;
          paidOnline: boolean | null;
          price: Array<{
            price: number | null;
            code: string | null;
          } | null> | null;
        } | null;
        onlinePayments: {
          isSet: boolean | null;
          dotPay: boolean | null;
          payPal: boolean | null;
          przelewy24: boolean | null;
        } | null;
        requiredPrePayment: {
          alreadyPaid: boolean | null;
          isSet: boolean | null;
          prePaidOption: Types.PrepaidOptions | null;
          price: Array<{
            code: string | null;
            price: number | null;
          } | null> | null;
        } | null;
      } | null;
      packageTraits: Array<{
        active: boolean | null;
        show: boolean | null;
        bookingPackageComponentId: string | null;
        value: Array<{
          language: string | null;
          text: string | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type UpdateBookingCategoryMutationVariables = Exact<{
  bookingSessionCategoryId: string;
  bookingSessionCategory: Types.BookingSessionCategoryInput;
}>;

export type UpdateBookingCategoryMutation = {
  updateBookingCategory: {
    parentId: string | null;
    bookingSessionCategoryId: string | null;
    deleted: boolean | null;
    visualPersonalization: string | null;
    order: number | null;
    imagesCount: {
      all: number | null;
      hasPeople: boolean | null;
      imagesCountId: string | null;
      uploadInProgress: number | null;
    } | null;
    title: Array<{
      text: string | null;
      language: string | null;
    } | null> | null;
    description: Array<{
      text: string | null;
      language: string | null;
    } | null> | null;
    cover: {
      coverSetupId: string | null;
      file: string | null;
      x: number | null;
      y: number | null;
      size: { w: number | null; h: number | null } | null;
    } | null;
    bookingPackageComponents: Array<{
      addToAll: boolean | null;
      bookingPackageComponentId: string | null;
      name: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      value: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
    } | null> | null;
    photoPackages: Array<{
      locksDayAfter: boolean | null;
      recommended: boolean | null;
      level: number | null;
      color: string | null;
      deleted: boolean | null;
      bookingPhotoPackageId: string | null;
      preReservationBuffer: number | null;
      duration: number | null;
      beforeTime: number | null;
      beforeTimeActive: boolean | null;
      afterTime: number | null;
      afterTimeActive: boolean | null;
      marketingDescription: string | null;
      slotOnly: boolean | null;
      timeToConfirm: number | null;
      currencyId: string | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      title: Array<{
        text: string | null;
        language: string | null;
      } | null> | null;
      messageToClient: Array<{
        text: string | null;
        language: string | null;
      } | null> | null;
      availableBookingPackageAdditions: Array<{
        usedBookingPackageAdditionId: string | null;
        affectPrice: boolean | null;
        affectDuration: boolean | null;
        duration: number | null;
        limit: number | null;
        price: Array<{
          code: string | null;
          price: number | null;
        } | null> | null;
        title: Array<{
          language: string | null;
          text: string | null;
        } | null> | null;
      } | null> | null;
      settlements: {
        basicSessionPrice: {
          isSet: boolean | null;
          alreadyPaid: boolean | null;
          paidOnline: boolean | null;
          price: Array<{
            price: number | null;
            code: string | null;
          } | null> | null;
        } | null;
        onlinePayments: {
          isSet: boolean | null;
          dotPay: boolean | null;
          payPal: boolean | null;
          przelewy24: boolean | null;
        } | null;
        requiredPrePayment: {
          alreadyPaid: boolean | null;
          isSet: boolean | null;
          prePaidOption: Types.PrepaidOptions | null;
          price: Array<{
            code: string | null;
            price: number | null;
          } | null> | null;
        } | null;
      } | null;
      packageTraits: Array<{
        active: boolean | null;
        show: boolean | null;
        bookingPackageComponentId: string | null;
        value: Array<{
          language: string | null;
          text: string | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetBookingPreviewUrlQueryVariables = Exact<{
  organizationId: string;
}>;

export type GetBookingPreviewUrlQuery = { getBookingPreviewURL: string | null };

export type SetBookingPreviewUrlMutationVariables = Exact<{
  organizationId: string;
}>;

export type SetBookingPreviewUrlMutation = {
  setBookingPreviewURL: string | null;
};

export type GetBookingConfigQueryVariables = Exact<{
  organizationId: string;
}>;

export type GetBookingConfigQuery = {
  getBookingConfig: {
    personalization: string | null;
    banner: {
      y: number | null;
      x: number | null;
      file: string | null;
      coverSetupId: string | null;
      size: { h: number | null; w: number | null } | null;
    } | null;
  } | null;
};

export type UpdateBookingConfigMutationVariables = Exact<{
  organizationId: string;
  bookingConfig: Types.BookingConfigInput;
}>;

export type UpdateBookingConfigMutation = {
  updateBookingConfig: {
    personalization: string | null;
    banner: {
      y: number | null;
      x: number | null;
      file: string | null;
      coverSetupId: string | null;
      size: { h: number | null; w: number | null } | null;
    } | null;
  } | null;
};

export const ScheduleEventFragmentDoc = gql`
  fragment ScheduleEvent on ScheduleEvent {
    userId
    type
    scheduleEventId
    status
    created
    afterBuffer
    beforeBuffer
    comment
    endsAt
    gdprSeen
    isRecur
    locksDayAfter
    prepaidAmount
    prepaidDeadline
    startsAt
    prepaidPaid
    title
    recurConfig {
      value
      dayOfAWeekRepeat
      endsAtDate
      excluded
      monthRecur
      endsAtType
      unit
    }
    packages
    oldClientId
    organizationClientId
    questionnaireAnswers
    questionnaireSent
    newSessionId
    hasNewPricing
  }
`;
export const BookingSessionCategoryFragmentDoc = gql`
  fragment bookingSessionCategory on BookingSessionCategory {
    imagesCount {
      all
      hasPeople
      imagesCountId
      uploadInProgress
    }
    title {
      text
      language
    }
    parentId
    bookingSessionCategoryId
    deleted
    visualPersonalization
    description {
      text
      language
    }
    order
    cover {
      coverSetupId
      file
      size {
        w
        h
      }
      x
      y
    }
    bookingPackageComponents {
      addToAll
      name {
        language
        text
      }
      value {
        language
        text
      }
      bookingPackageComponentId
    }
    photoPackages {
      locksDayAfter
      recommended
      level
      color
      price {
        code
        price
      }
      deleted
      title {
        text
        language
      }
      bookingPhotoPackageId
      preReservationBuffer
      duration
      beforeTime
      beforeTimeActive
      afterTime
      afterTimeActive
      marketingDescription
      messageToClient {
        text
        language
      }
      slotOnly
      timeToConfirm
      currencyId
      availableBookingPackageAdditions {
        usedBookingPackageAdditionId
        affectPrice
        affectDuration
        price {
          code
          price
        }
        title {
          language
          text
        }
        duration
        limit
      }
      settlements {
        basicSessionPrice {
          price {
            price
            code
          }
          isSet
          alreadyPaid
          paidOnline
        }
        onlinePayments {
          isSet
          dotPay
          payPal
          przelewy24
        }
        requiredPrePayment {
          alreadyPaid
          isSet
          prePaidOption
          price {
            code
            price
          }
        }
      }
      packageTraits {
        value {
          language
          text
        }
        active
        show
        bookingPackageComponentId
      }
      preReservationBuffer
    }
  }
`;
export const GetMineScheduleEventsDocument = gql`
  query GetMineScheduleEvents($userId: Int) {
    getAllScheduleEventsForUser(userId: $userId) {
      ...ScheduleEvent
    }
  }
  ${ScheduleEventFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetMineScheduleEventsGQL extends Apollo.Query<
  GetMineScheduleEventsQuery,
  GetMineScheduleEventsQueryVariables
> {
  document = GetMineScheduleEventsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAllMinePackagesDocument = gql`
  query getAllMinePackages($organizationId: ID!) {
    getAllMinePackages(organizationId: $organizationId) {
      level
      color
      price
      status
      title
      photoPackageId
      duration
      beforeTime
      afterTime
      marketingDescription
      messageToClient
      sessionCategoryId
      slotOnly
      refundablePrepaid
      unrefundablePrepaid
      timeToConfirm
      currencyId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllMinePackagesGQL extends Apollo.Query<
  GetAllMinePackagesQuery,
  GetAllMinePackagesQueryVariables
> {
  document = GetAllMinePackagesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAllMineSessionCategoriesDocument = gql`
  query getAllMineSessionCategories($organizationId: ID!) {
    getAllMineSessionCategories(organizationId: $organizationId) {
      title
      parentId
      sessionCategoryId
      status
      fileName
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllMineSessionCategoriesGQL extends Apollo.Query<
  GetAllMineSessionCategoriesQuery,
  GetAllMineSessionCategoriesQueryVariables
> {
  document = GetAllMineSessionCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAllMineBookingSessionCategoriesDocument = gql`
  query getAllMineBookingSessionCategories($organizationId: ID!) {
    getAllMineBookingSessionCategories(organizationId: $organizationId) {
      ...bookingSessionCategory
    }
  }
  ${BookingSessionCategoryFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllMineBookingSessionCategoriesGQL extends Apollo.Query<
  GetAllMineBookingSessionCategoriesQuery,
  GetAllMineBookingSessionCategoriesQueryVariables
> {
  document = GetAllMineBookingSessionCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetScheduleEventOldTemplateIdDocument = gql`
  query getScheduleEventOldTemplateId($scheduleEventId: ID!) {
    getScheduleEventOldTemplateId(scheduleEventId: $scheduleEventId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetScheduleEventOldTemplateIdGQL extends Apollo.Query<
  GetScheduleEventOldTemplateIdQuery,
  GetScheduleEventOldTemplateIdQueryVariables
> {
  document = GetScheduleEventOldTemplateIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetOrganizationClientIdForScheduleEventDocument = gql`
  query getOrganizationClientIdForScheduleEvent(
    $scheduleEventId: ID!
    $organizationId: ID!
  ) {
    getOrganizationClientIdForScheduleEvent(
      scheduleEventId: $scheduleEventId
      organizationId: $organizationId
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetOrganizationClientIdForScheduleEventGQL extends Apollo.Query<
  GetOrganizationClientIdForScheduleEventQuery,
  GetOrganizationClientIdForScheduleEventQueryVariables
> {
  document = GetOrganizationClientIdForScheduleEventDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetListOfOldPrivateSessionTemplatesDocument = gql`
  query getListOfOldPrivateSessionTemplates {
    getMineOldPrivateSessionConfigTemplates {
      configId
      name
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetListOfOldPrivateSessionTemplatesGQL extends Apollo.Query<
  GetListOfOldPrivateSessionTemplatesQuery,
  GetListOfOldPrivateSessionTemplatesQueryVariables
> {
  document = GetListOfOldPrivateSessionTemplatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AddScheduleEventToPrivateSessionDocument = gql`
  mutation addScheduleEventToPrivateSession(
    $scheduleEventId: ID!
    $privateSessionId: ID!
  ) {
    addScheduleEventToPrivateSession(
      scheduleEventId: $scheduleEventId
      privateSessionId: $privateSessionId
    ) {
      scheduleEventId
      newSessionId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AddScheduleEventToPrivateSessionGQL extends Apollo.Mutation<
  AddScheduleEventToPrivateSessionMutation,
  AddScheduleEventToPrivateSessionMutationVariables
> {
  document = AddScheduleEventToPrivateSessionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateScheduleEventDocument = gql`
  mutation updateScheduleEvent(
    $scheduleEventId: ID!
    $scheduleEvent: ScheduleEventInput!
  ) {
    updateScheduleEvent(
      scheduleEventId: $scheduleEventId
      scheduleEvent: $scheduleEvent
    ) {
      scheduleEventId
      ...ScheduleEvent
    }
  }
  ${ScheduleEventFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateScheduleEventGQL extends Apollo.Mutation<
  UpdateScheduleEventMutation,
  UpdateScheduleEventMutationVariables
> {
  document = UpdateScheduleEventDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const InsertScheduleEventDocument = gql`
  mutation insertScheduleEvent(
    $scheduleEventId: ID!
    $scheduleEvent: ScheduleEventInput!
  ) {
    insertScheduleEvent(
      scheduleEventId: $scheduleEventId
      scheduleEvent: $scheduleEvent
    ) {
      scheduleEventId
      ...ScheduleEvent
    }
  }
  ${ScheduleEventFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class InsertScheduleEventGQL extends Apollo.Mutation<
  InsertScheduleEventMutation,
  InsertScheduleEventMutationVariables
> {
  document = InsertScheduleEventDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ScheduleEventUpdatedDocument = gql`
  subscription scheduleEventUpdated($organizationId: ID!) {
    scheduleEventUpdated(organizationId: $organizationId) {
      ...ScheduleEvent
    }
  }
  ${ScheduleEventFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ScheduleEventUpdatedGQL extends Apollo.Subscription<
  ScheduleEventUpdatedSubscription,
  ScheduleEventUpdatedSubscriptionVariables
> {
  document = ScheduleEventUpdatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ScheduleEventAddedDocument = gql`
  subscription scheduleEventAdded($organizationId: ID!) {
    scheduleEventAdded(organizationId: $organizationId) {
      ...ScheduleEvent
    }
  }
  ${ScheduleEventFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ScheduleEventAddedGQL extends Apollo.Subscription<
  ScheduleEventAddedSubscription,
  ScheduleEventAddedSubscriptionVariables
> {
  document = ScheduleEventAddedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GenerateGoogleCalendarAuthLinkDocument = gql`
  query generateGoogleCalendarAuthLink {
    generateGoogleCalendarAuthLink
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GenerateGoogleCalendarAuthLinkGQL extends Apollo.Query<
  GenerateGoogleCalendarAuthLinkQuery,
  GenerateGoogleCalendarAuthLinkQueryVariables
> {
  document = GenerateGoogleCalendarAuthLinkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetMineWorkingHoursDocument = gql`
  query getMineWorkingHours {
    getMineWorkingHours {
      day
      endsAt
      startsAt
      isWorking
      workingHourId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMineWorkingHoursGQL extends Apollo.Query<
  GetMineWorkingHoursQuery,
  GetMineWorkingHoursQueryVariables
> {
  document = GetMineWorkingHoursDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetBookingPhotoAdditionsDocument = gql`
  query getBookingPhotoAdditions($organizationId: ID!) {
    getBookingPhotoAdditions(organizationId: $organizationId) {
      duration
      deleted
      description {
        text
        language
      }
      price {
        code
        price
      }
      affectDuration
      affectPrice
      name {
        text
        language
      }
      bookingPackageAdditionId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetBookingPhotoAdditionsGQL extends Apollo.Query<
  GetBookingPhotoAdditionsQuery,
  GetBookingPhotoAdditionsQueryVariables
> {
  document = GetBookingPhotoAdditionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateBookingPhotographersSortOrderDocument = gql`
  mutation updateBookingPhotographersSortOrder(
    $bookingSort: [BookingPhotographerSortInput]
  ) {
    updateBookingPhotographersSortOrder(bookingPhotographerSort: $bookingSort) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateBookingPhotographersSortOrderGQL extends Apollo.Mutation<
  UpdateBookingPhotographersSortOrderMutation,
  UpdateBookingPhotographersSortOrderMutationVariables
> {
  document = UpdateBookingPhotographersSortOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateBookingCategoriesSortOrderDocument = gql`
  mutation updateBookingCategoriesSortOrder(
    $bookingSort: [BookingCategorySortInput]
  ) {
    updateBookingCategoriesSortOrder(bookingCategorySort: $bookingSort) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateBookingCategoriesSortOrderGQL extends Apollo.Mutation<
  UpdateBookingCategoriesSortOrderMutation,
  UpdateBookingCategoriesSortOrderMutationVariables
> {
  document = UpdateBookingCategoriesSortOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateBookingPackagesSortOrderDocument = gql`
  mutation updateBookingPackagesSortOrder(
    $bookingSort: [BookingPackageSortInput]
  ) {
    updateBookingPackagesSortOrder(bookingPackageSort: $bookingSort) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateBookingPackagesSortOrderGQL extends Apollo.Mutation<
  UpdateBookingPackagesSortOrderMutation,
  UpdateBookingPackagesSortOrderMutationVariables
> {
  document = UpdateBookingPackagesSortOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const InsertBookingCategoryDocument = gql`
  mutation insertBookingCategory(
    $organizationId: ID!
    $bookingSessionCategory: BookingSessionCategoryInsert!
  ) {
    insertBookingCategory(
      organizationId: $organizationId
      bookingSessionCategory: $bookingSessionCategory
    ) {
      ...bookingSessionCategory
    }
  }
  ${BookingSessionCategoryFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class InsertBookingCategoryGQL extends Apollo.Mutation<
  InsertBookingCategoryMutation,
  InsertBookingCategoryMutationVariables
> {
  document = InsertBookingCategoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateBookingCategoryDocument = gql`
  mutation updateBookingCategory(
    $bookingSessionCategoryId: ID!
    $bookingSessionCategory: BookingSessionCategoryInput!
  ) {
    updateBookingCategory(
      bookingSessionCategoryId: $bookingSessionCategoryId
      bookingSessionCategory: $bookingSessionCategory
    ) {
      ...bookingSessionCategory
    }
  }
  ${BookingSessionCategoryFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateBookingCategoryGQL extends Apollo.Mutation<
  UpdateBookingCategoryMutation,
  UpdateBookingCategoryMutationVariables
> {
  document = UpdateBookingCategoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetBookingPreviewUrlDocument = gql`
  query getBookingPreviewURL($organizationId: ID!) {
    getBookingPreviewURL(organizationId: $organizationId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetBookingPreviewUrlGQL extends Apollo.Query<
  GetBookingPreviewUrlQuery,
  GetBookingPreviewUrlQueryVariables
> {
  document = GetBookingPreviewUrlDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetBookingPreviewUrlDocument = gql`
  mutation setBookingPreviewURL($organizationId: ID!) {
    setBookingPreviewURL(organizationId: $organizationId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SetBookingPreviewUrlGQL extends Apollo.Mutation<
  SetBookingPreviewUrlMutation,
  SetBookingPreviewUrlMutationVariables
> {
  document = SetBookingPreviewUrlDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetBookingConfigDocument = gql`
  query getBookingConfig($organizationId: ID!) {
    getBookingConfig(organizationId: $organizationId) {
      personalization
      banner {
        y
        x
        file
        coverSetupId
        size {
          h
          w
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetBookingConfigGQL extends Apollo.Query<
  GetBookingConfigQuery,
  GetBookingConfigQueryVariables
> {
  document = GetBookingConfigDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateBookingConfigDocument = gql`
  mutation updateBookingConfig(
    $organizationId: ID!
    $bookingConfig: BookingConfigInput!
  ) {
    updateBookingConfig(
      organizationId: $organizationId
      bookingConfig: $bookingConfig
    ) {
      personalization
      banner {
        y
        x
        file
        coverSetupId
        size {
          h
          w
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateBookingConfigGQL extends Apollo.Mutation<
  UpdateBookingConfigMutation,
  UpdateBookingConfigMutationVariables
> {
  document = UpdateBookingConfigDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
